import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Col, Alert, Table, Spinner, Button } from 'react-bootstrap';
import PesquisaService from '../../../../services/pesquisa-auth';
import Pesquisa from './pesquisa';
import { Link } from 'react-router-dom';

const ListarPesquisas = () => {
    const [pesquisas, setPesquisas] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [medias, setMedias] = useState([]);
    const [error, setError] = useState(null);

    const fetchMedias = async () => {
        try {
            const response = await PesquisaService.medias();
            setMedias(response.data);
        } catch (error) {
            console.log(error);
        }
    };


    async function fetchPesquisas() {
        await fetchMedias()
        const response = await PesquisaService.listar();
        if (response.data.length >= 1) {
            setPesquisas(response.data)
            setVazio(false)
        } else {
            setPesquisas([])
            setVazio(true)
        }
    }


    useEffect(() => {
        fetchPesquisas();
    }, []);

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a pesquisa?')) {
            await PesquisaService.deletar(id)
            alert("Pesquisa deletada com sucesso!")
            fetchPesquisas();
        }
    }

    return (
        <Fragment>
            <Row xs={1}>
                <Col xs={{ span: 2, offset: 11 }}>
                    <Link to='/restrito/ouvidoria'>
                        <Button type='button' variant='danger'>Voltar</Button>
                    </Link>
                </Col>
            </Row>
            <h5>Resultados de Pesquisa de Satisfação</h5>
            {vazio ? <Fragment>
                <Alert variant='danger'>Nenhuma pesquisa recebida ainda :(</Alert>
            </Fragment> :
                <Fragment>
                    <Row>
                        {medias.length > 0 ?
                            <Fragment>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Órgão</th>
                                            <th>Média</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {medias.map((media, index) => (
                                            <tr key={index}>
                                                <td>{media.orgao}</td>
                                                <td>{media.mediaNota}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Fragment>
                            : <Spinner animation="border" role="status">
                                <span className="visually-hidden">Carregando...</span>
                            </Spinner>}
                    </Row>
                    <br/>
                    <h5>Pesquisas registradas</h5>
                    <br/>
                    <Row xs={1} lg={1}>
                        {pesquisas.map((pesquisa, index) =>
                            <Pesquisa
                                fetchPesquisas={fetchPesquisas}
                                pesquisa={pesquisa}
                                key={index}
                                deletar={deletar}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarPesquisas;